function startSectionObserver() {
  var observeContainers = document.querySelectorAll('dl.ingredients');
  observeContainers.forEach(function (observeContainer) {
    observeContainer.classList.add('observe');
    var observeElements = observeContainer.querySelectorAll('.ingredient');
    observeElements.forEach(function (element) {
      var observer = new window.IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              element.classList.add('active');
              return;
            }
            element.classList.remove('active');
          });
        },
        {
          rootMargin: '100% 0% -40% 0%',
          threshold: 0 // set offset 0.1 means trigger if at least 10% of element in viewport
        }
      );
      observer.observe(element);
    });
  });
}
if ('IntersectionObserver' in window) {
  startSectionObserver();
}
